import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getGroupUiVisibility,
  getGroupUiVisibilityResolved,
  putGroupUiVisibility,
  deleteGroupUiVisibility,
} from 'services/api';
import type { MenuVisibility } from 'menu/types';

type Tree = Record<string, MenuVisibility>;

/** Carga el árbol resuelto (con herencia ancestral) para el grupo del usuario logueado. */
export const getCurrentUserVisibilityAsync = createAsyncThunk(
  'uiVisibility/getCurrentUserVisibility',
  async (_: void, { getState }) => {
    const state: any = getState();
    const userLogged = state.common.user.userLogged;
    const groupId = userLogged?.group?.id || userLogged?.groupId;
    if (!groupId) {
      // eslint-disable-next-line no-console
      console.warn('[uiVisibility] userLogged sin groupId — se omite la llamada', userLogged);
      return {} as Tree;
    }
    const response = await getGroupUiVisibilityResolved(groupId);
    return (response?.data?.item || response?.data || {}) as Tree;
  }
);

/** Carga el árbol resuelto para un grupo arbitrario (preview en el editor). */
export const getResolvedUiVisibilityAsync = createAsyncThunk(
  'uiVisibility/getResolved',
  async (groupId: string) => {
    const response = await getGroupUiVisibilityResolved(groupId);
    return {
      groupId,
      tree: (response?.data?.item || response?.data || {}) as Tree,
    };
  }
);

/** Carga el override propio (sin merge) para el editor. Devuelve {} si el grupo hereda. */
export const getOwnUiVisibilityAsync = createAsyncThunk(
  'uiVisibility/getOwn',
  async (groupId: string) => {
    const response = await getGroupUiVisibility(groupId);
    return {
      groupId,
      tree: (response?.data?.item || response?.data || {}) as Tree,
    };
  }
);

/** Guarda el override del grupo. */
export const putUiVisibilityAsync = createAsyncThunk(
  'uiVisibility/put',
  async ({ groupId, tree }: { groupId: string; tree: Tree }) => {
    const response = await putGroupUiVisibility(groupId, tree);
    return { groupId, tree, response: response?.data };
  }
);

/** Elimina el override del grupo (vuelve a heredar). */
export const deleteUiVisibilityAsync = createAsyncThunk(
  'uiVisibility/delete',
  async (groupId: string) => {
    await deleteGroupUiVisibility(groupId);
    return { groupId };
  }
);
